import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Scrolls to top of page on route changes
 * Handles both page navigation and hash-based section navigation
 */
export const useScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // If there's a hash, scroll to that element
    if (hash) {
      // Wait for the DOM to be ready
      const scrollToHash = () => {
        const element = document.getElementById(hash.slice(1));
        if (element) {
          const headerOffset = 80; // Account for fixed header
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.scrollY - headerOffset;
          
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      };
      
      // Try immediately, then retry after a short delay for lazy-loaded content
      scrollToHash();
      setTimeout(scrollToHash, 100);
    } else {
      // No hash - scroll to top of page
      window.scrollTo({
        top: 0,
        behavior: 'instant'
      });
    }
  }, [pathname, hash]);
};

export default useScrollToTop;
